import Requests from './requests';

export default Requests;
